module.exports = __webpack_public_path__ + "img/allow-permissions.8927e96d.png";